import { render, staticRenderFns } from "./ckCheckDetail.vue?vue&type=template&id=136511ac&"
import script from "./ckCheckDetail.vue?vue&type=script&lang=js&"
export * from "./ckCheckDetail.vue?vue&type=script&lang=js&"
import style0 from "./ckCheckDetail.vue?vue&type=style&index=0&id=136511ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports